import styled from 'styled-components';

export const NavHeader = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: ${(props) => props.theme['plugin.categories.header.color']};
  margin-bottom: 5px;
`;

export const CategoriesNav = styled.div`
  overflow: auto;
  max-width: 200px;
  flex: 1 0 100px;

  text-transform: capitalize;
  padding-right: 10px;
`;

export const NavItem = styled.button`
  text-align: left;
  font-size: 14px;
  font-weight: normal;
  font: inherit;
  line-height: 19px;
  color: ${(props) => props.theme['plugin.categories.color']};

  width: 100%;
  height: 38px;
  padding: 0;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover, &:focus {
    color: ${(props) => props.theme['color.primary.text']};;
    outline: none;
    cursor: pointer;
  }

  ${(props) => props.active && `
    color: ${props.theme['color.primary.text']};
  `}
`;

export const HorizontalRule = styled.div`
  border-bottom: 1px solid #D9D9DE;
  margin: 27px 0 25px 0;
`;
